import React from "react";
import { observer } from "mobx-react-lite";
import { Col, Row } from "react-bootstrap";
import PayGateRefundDetailViewModel from "../../../../viewModels/finance/refundApprovals/payGateRefunds/payGateRefundDetailViewModel";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import PayGateOrderSectionView from "./payGateOrderSectionView";
import PayGateRefundSectionView from "./payGateRefundSectionView";
import PayGateRefundPaymentSectionView from "../detail/payGateRefundPaymentSectionView";
import RefundDetailView from "../refundDetailView";

const PayGateRefundDetailView: ViewComponent<PayGateRefundDetailViewModel> = observer(({ vm }) => {
  return (
    <RefundDetailView vm={vm}>
      <Row>
        <Col lg={12} xl={5} className="mb-4 mb-lg-0">
          <Row className="mb-4">
            <Col>
              <PayGateOrderSectionView vm={vm} />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col>
              <PayGateRefundSectionView vm={vm} />
            </Col>
          </Row>
        </Col>
        <Col lg={12} xl={7}>
          <PayGateRefundPaymentSectionView vm={vm} />
        </Col>
      </Row>
    </RefundDetailView>
  );
});

registerView(PayGateRefundDetailView, PayGateRefundDetailViewModel);
